import {combineReducers, configureStore} from "@reduxjs/toolkit";
import CalendarReducer from "./reducers/calendarReducer";
import DiaryReducer from "./reducers/diaryReducer";
import UserReducer from "./reducers/userReducer";
import PostPracticeReducer from "./reducers/postPracticeReducer";
import CuratorialGroupReducer from "./reducers/curatorialGroupReducer";
import pagesConfigReducer from "./reducers/pagesConfigReducer";

const appReducer = combineReducers({
    calendar: CalendarReducer,
    diary: DiaryReducer,
    user: UserReducer,
    postPractice: PostPracticeReducer,
    curatorialGroup: CuratorialGroupReducer,
    pagesConfigReducer: pagesConfigReducer,
});

export const RESET_APP = "RESET_APP";

export const rootReducer = (
    state: ReturnType<typeof appReducer> | undefined,
    action: any
) => {
    if (action.type === RESET_APP) {
        state = undefined;
    }

    return appReducer(state, action);
};

export const store = configureStore({
    reducer: rootReducer,
    devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
